import module from 'contabilidad/polizas/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('contabilidad.polizas.deudoresDiversos', {
    url: '/deudoresDiversos?{fecha_inicio:date}&{fecha_fin:date}&{id_operadora}&{ids_empresas}',
    data: {
      title: 'Deudores Diversos Diario',
    },
    reloadOnSearch: false,
    params: {
      ids_empresas: {array: true},
    },
    resolve: {
      fechaInicio: ($stateParams) => $stateParams.fecha_inicio,
      fechaFin: ($stateParams) => $stateParams.fecha_fin,
      idOperadora: ($stateParams) => $stateParams.id_operadora,
      idsEmpresas: ($stateParams) => $stateParams.ids_empresas,
    },
    views: {
      '@contabilidad': {
        template: '<contabilidad-polizas-deudoresdiversos fecha-inicio="fechaInicio" fecha-fin="fechaFin" id-operadora="idOperadora" ids-empresas="idsEmpresas"/>',
        controller: ($scope, fechaInicio, fechaFin, idOperadora, idsEmpresas) => {
          $scope.fechaInicio = fechaInicio
          $scope.fechaFin = fechaFin
          $scope.idOperadora = idOperadora
          $scope.idsEmpresas = idsEmpresas
        },
      },
    },
  })
})



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/routes/polizas/deudoresDiversos.js